export default "__VITE_ASSET__BD6ojFHF__"